module.exports = __webpack_public_path__ + "middle-img.png?94de8ae4a3a69c90a26ea3c7c85fb6b7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ProductAndService/MOBEC/middle-img.png
// module id = 170
// module chunks = 0